import component from "./ProfileHome.vue"

import wrapVueComponent from "@/utils/wrapVueComponent"
const componentName = "StudentProfileHome"

export default wrapVueComponent(componentName, component)
